import { CheckIcon } from "@phosphor-icons/react";
import { useTranslate } from "@refinedev/core";
import { Flex, Typography } from "antd";
import { useAntTheme } from "hooks/useAntTheme";
import { radius } from "@libertify/ui";

const { Text, Title } = Typography;

interface ProjectGeneratingStateProps {
  userEmail?: string;
}

export const ProjectGeneratingState: React.FC<ProjectGeneratingStateProps> = ({
  userEmail,
}) => {
  const t = useTranslate();
  const { theme } = useAntTheme();

  const checkItems = [
    {
      key: "canLeave",
      text: t("media.projects.generating.canLeave"),
    },
    {
      key: "emailNotification",
      text: t("media.projects.generating.emailNotification", {
        email: userEmail,
      }),
    },
  ];

  return (
    <Flex
      vertical
      align="center"
      justify="center"
      gap={24}
      style={{
        padding: "48px 24px",
        backgroundColor: theme.colorBgLayout,
        borderRadius: radius.box,
        border: theme.cardBorder,
        minHeight: 300,
      }}
    >
      <Flex vertical align="center" gap={8}>
        <Title
          level={4}
          style={{
            margin: 0,
            color: theme.colorTextTitle,
            textAlign: "center",
          }}
        >
          {t("media.projects.generating.title")}
        </Title>
        <Text
          type="secondary"
          style={{
            fontSize: 14,
            textAlign: "center",
            maxWidth: 400,
          }}
        >
          {t("media.projects.generating.estimatedTime")}
        </Text>
      </Flex>

      <Flex vertical gap={4}>
        <Text
          type="secondary"
          style={{
            fontSize: 13,
            textAlign: "center",
          }}
        >
          {t("media.projects.generating.noNeedToStay")}
        </Text>
      </Flex>

      <Flex vertical gap={12} style={{ marginTop: 8 }}>
        {checkItems.map((item) => (
          <Flex key={item.key} align="center" gap={12}>
            <Flex
              align="center"
              justify="center"
              style={{
                width: 24,
                height: 24,
                borderRadius: radius.circle,
                backgroundColor: theme.colorPrimary,
                flexShrink: 0,
              }}
            >
              <CheckIcon size={14} color={theme.colorWhite} weight="bold" />
            </Flex>
            <Text style={{ fontSize: 14 }}>{item.text}</Text>
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
};
